import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faMoneyBillTransfer, faMoneyBillTrendUp, faSchool } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function EducacaoLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const [adm, setAdm] = useState(false)

    const nome = localStorage.getItem('nome');

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        console.log(user)
        switch (user) {
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect("/restrito/licitacao")
                break;
            case "Controle Interno":
                await setDirect("/restrito/controle")
                break;
            case "Saude":
                await setDirect("/restrito/saude")
                break;
            case "Obras":
                await setDirect("/restrito/obras")
                break;
            case "RH":
                await setDirect("/restrito/rh")
                break;
            case "Diario":
                await setDirect("/restrito/diario")
                break;
            case "Ouvidor":
                await setDirect("/restrito/ouvidoria")
                break;
            case "Administrador":
                await setAdm(true);
                break;
            case "Educação":
                await setDirect(false)
                break;
        }
    }


    const redireciona = async () => {
        await getNivel();
    }

    useEffect(() => {
        redireciona()
    }, [])


    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/educacao/documentos')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBook} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Documentos</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/educacao/receitas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faMoneyBillTrendUp} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Arrecadação</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/educacao/despesas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={3}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faMoneyBillTransfer} />
                                                </Col>
                                                <Col xs={9}>
                                                    <p className='titulo-lei'>Módulo de Despesas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {adm ?
                        <Fragment>
                            <br /><br />
                            <Link to={'/restrito'}>
                                <Button variant="danger" type="button">
                                    Voltar
                                </Button>
                            </Link>
                        </Fragment> : ''}
                </Container>
            </Fragment>
        );
    }
}

export default EducacaoLoggedScreen;